import { AppVariantConfig } from '@/types/app-config';

export const organizationsVariant: AppVariantConfig = {
  id: 'organizations',
  name: 'Organizations',
  description: 'Full-featured suite for large organizations',
  defaultRoute: 'home',
  appModules: {
    home: { enabled: true, requiresFeature: 'home' },
    directory: { enabled: true },
    marketplace: { 
      enabled: true, 
      requiresFeature: 'payments.marketplace',
      checkIfLive: true 
    },
    groups: { 
      enabled: true, 
      requiresFeature: 'groups.blog' 
    },
    portal: { 
      enabled: true, 
      requiresFeature: 'portal',
      subModules: {
        channels: { enabled: true, requiresFeature: 'channels' },
        events: { enabled: true, requiresFeature: 'events' },
        mail: { enabled: true, requiresFeature: 'mail' },
        addressBook: { enabled: true, requiresFeature: 'address_book' }
      }
    },
    payments: { 
      enabled: true, 
      requiresFeature: 'payments.donations',
      checkIfLive: true
    },
    archive: { enabled: true, requiresFeature: 'archive' }
  },
  adminModules: {
    users: { enabled: true },
    payments: { enabled: true },
    channels: { enabled: true },
    events: { enabled: true },
    mail: { enabled: true },
    address_book: { enabled: true },
    groups: { enabled: true },
    media: { enabled: true },
    archive: { enabled: true },
    analytics: { enabled: true },
    settings: { enabled: true },
    design: { enabled: true },
    roles: { enabled: true, requiresAdmin: true },
    onboarding: { enabled: true }
  }
}; 